// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__foDga","cell":"ColumnAccessor_cell__1x9wm","firstCellAccent":"ColumnAccessor_firstCellAccent__Lhrq3"};